export default "__VITE_ASSET__DnDhO6CX__"